<!-- eslint-disable -->
<template>
  <div
    class="quote-print-shown w-full"
    :class="{ 'draft-watermark': quoteIsDraft }"
    :data-quote-terms-template="quoteTermsTemplate"
  >
    <!-- Header Images -->
    <div class="flex">
      <span class="col-4">
        <img
          class="summit-logo"
          src="/img/Summit-Logo-RGB-Transparent.png"
          alt="summit logo"
          data-cy="summit-logo"
          height="70"
          crossorigin="anonymous"
        />
      </span>
      <span class="col-8 quote-header-bg-image relative">
        <h2 class="text-white text-right quote-p-r-12">Quotation</h2>
      </span>
    </div>

    <!-- Header Information -->
    <h1>{{ quote?.name }}</h1>
    <div class="flex">
      <span>{{ formatVersionNumber(quote?.sk_proposal_number) }}.v{{ quote?.version_number }}</span>
      <span class="quote-flex-grow"></span>
      <span>{{ quotePrintedDate }}</span>
    </div>
    <div class="flex-col border-2 quote-wrap-words">
      <div class="w-full bg-gray-400 flex">
        <span class="col-6"><b>Customer Details</b></span>
        <span class="col-3"><b>Well Details</b></span>
        <span class="col-3"><b>Quote Details</b></span>
      </div>
      <div class="w-full flex">
        <span class="col-3 quote-border-r-2"
          ><b>Sold To:</b><br />{{ quote?.erp_customer_name }}</span
        >
        <span class="col-3 quote-border-r-2"
          ><b>Ship To:</b><br />{{ quote?.erp_address_name }}</span
        >
        <span class="col-3 quote-border-r-2">
          <p>{{ quote?.erp_well_name }} ({{ quote?.erp_well_uwi }})</p>
          <p><b>Field:</b></p>
          <p><b>Country:</b>{{ quote?.erp_well_country }}</p>
          <p><b>State:</b>{{ quote?.erp_well_region }}</p>
        </span>
        <span class="col-3">
          <b>HESI Rep:</b><br />
          <p class="text-xs">{{ quote?.customer_rep_name }}</p>
          <p class="text-xs">{{ quote?.customer_rep_email }}</p>
          <p class="text-xs">{{ quote?.customer_rep_phone_number }}</p>
          <br>
          <b>Job Type:</b>
          <p class="text-xs" v-if="isJobTypeWellTestRental(quote?.sk_job_type)">Rental</p>
          <p class="text-xs" v-else>Sale</p>
        </span>
      </div>
    </div>
    <div v-if="quote?.comments">
      <h2><b>Notes:</b></h2>
      <div class="w-full quote-h-16 border-2">{{ quote?.comments }}</div>
    </div>
    <div v-if="quote?.directions">
      <h2><b>Directions:</b></h2>
      <div class="w-full quote-h-16 border-2">{{ quote?.directions }}</div>
    </div>
    <br />

    <!-- Line Item Table -->
    <div class="bg-gray-400 quote-border-b-2 flex text-center text-sm">
      <span class="p-2"><b>#</b></span>
      <span class="p-2 quote-flex-grow"><b>Description</b></span>
      <span class="p-2 col-2 text-center"
        ><b>Unit Price({{ quote?.currency }})</b></span
      >
      <span
        class="p-2 col-3 text-center"
        v-if="isJobTypeWellTestRental(quote?.sk_job_type)"
      >
        <b>Consumable</b>
      </span>
      <span class="p-2 col-1"><b>Qty</b></span>
      <span class="p-2 col-2 text-right"><b>Total ({{ quote?.currency }})</b></span>
    </div>
    <div
      v-for="(item, index) in quote?.quote_line_items"
      :key="item.id"
      class="flex text-sm quote-border-b-2"
    >
      <span class="p-2">{{ (index + 1) * 10 }}</span>
      <span class="quote-flex-grow text-xs quote-desc-column">
        <p>
          {{ item?.erp_material_number }} - {{ item?.erp_material_long_description }}
        </p>
        <p v-if="item?.note" class="text-xs"><b>Notes: </b>{{ item?.note }}</p>
      </span>
      <span class="p-2 col-2 text-right">{{ item.tax_type === "free" ? formatCurrency(0, quote?.currency, false) : formatCurrency(getQuoteLineUnitPrice(item), quote?.currency, false) }}</span>
      <span
        class="p-2 col-3 text-center"
        v-if="isJobTypeWellTestRental(quote?.sk_job_type)"
      >
        {{ item.subcategory === "reusable" ? "non-consumable" : "consumable"}}
      </span>
      <span class="p-2 col-1 text-center">{{ item?.quantity }}</span>

      <span class="p-2 col-2 text-right">{{ item.tax_type === "free" ? formatCurrency(0, quote?.currency, false) : formatCurrency((getQuoteLineUnitPrice(item) * item.quantity) || 0, quote?.currency, false) }}</span>
    </div>
    <br />
    <div class="flex flex-row quote-pb-avoid">
      <!-- Well Test Totals -->
      <div class="quote-flex-grow p-2">
        <div v-if="isCanadaWellTest() || isUsaWellTest()" class="p-0">
          <div class="text-center text-lg p-2 bg-gray-400">
            <b>Well Test Option</b>
          </div>
          <div class="flex border-y-2">
            <div class="col-4 bg-gray-400 border-x-2 p-2 text-center text-xs">
              <b>Consumables + Services + 1st Month Rent</b>
            </div>
            <div class="col-8 p-2 quote-border-r-2 text-right">
              {{ totals.lineItemsConsumableServiceMonthlyAggregate }}
            </div>
          </div>
          <div class="flex quote-border-b-2">
            <div class="col-4 bg-gray-400 border-x-2 p-2 text-center text-xs">
              <b>Import Surcharges</b>
            </div>
            <div class="col-8 p-2 quote-border-r-2 text-right">
              {{ totals.lineItemsImportPrice }}
            </div>
          </div>
          <div class="flex quote-border-b-2">
            <div class="col-4 bg-gray-400 border-x-2 p-2 text-center text-xs">
              <b>Sales Tax</b>
            </div>
            <div class="col-8 p-2 quote-border-r-2 text-right">(1)</div>
          </div>
          <div class="flex quote-border-b-2">
            <div class="col-4 bg-gray-400 border-x-2 p-2 text-center text-xs">
              <b>Total</b>
            </div>
            <div class="col-8 p-2 quote-border-r-2 text-right">{{ totals?.lineItemsConsumableServiceMonthlyAggregate }}</div>
          </div>
          <div class="flex quote-border-b-2">
            <div class="col-4 bg-gray-400 border-x-2 p-2 text-center text-xs">
              <b>Daily Rental</b>
            </div>
            <div class="col-8 p-2 quote-border-r-2 text-right">{{ totals?.dailyFee }}</div>
          </div>
          <br />
        </div>
        <div>
          <b>Approval:____________________ Date:_____________</b>
        </div>
        <p v-if="isCanadaWellTest()" class="text-sm">
          This transaction is governed by the Well Test Agreement terms and
          conditions set forth herein, which incorporate by reference the
          Halliburton Group Canada Standard Terms and Conditions, also attached
          hereto, other than any provisions which are superseded by specific
          written terms pertaining to the same subject matter and which are
          included in a current MSA (as defined below), if any.
        </p>
        <p v-if="isCanadaDirectSale()" class="text-sm">
          This transaction is governed by Halliburton Group Canada (HGC) ESP
          Standard Terms and Conditions (Sales, Lease, Services) attached
          herein, other than provisions which are superseded by specific written
          terms and conditions agreed to by HGC and included in a Master Service
          Agreement or Contract.
        </p>
        <p v-if="isUsaWellTest()" class="text-sm">
          This transaction is governed by the Well Test Agreement terms and
          conditions set forth herein, which incorporate by reference the
          Halliburton Energy Services, Inc. Standard Terms and Conditions, also
          attached hereto, other than any provisions which are superseded by
          specific written terms pertaining to the same subject matter and which
          are included in a current MSA (as defined below), if any.
        </p>
        <p v-if="isUsaDirectSale()" class="text-sm">
          This transaction is governed by Halliburton Energy Services, Inc.
          (“HESI”) ESP Standard Terms and Conditions (Sales, Lease, Services)
          attached herein, other than provisions which are superseded by
          specific written terms and conditions agreed to by HESI and included
          in a Master Service Agreement or Contract.
        </p>
      </div>

      <!-- Sale Totals -->
      <div class="col-5 p-0">
        <div
          v-if="isCanadaWellTest() || isUsaWellTest()"
          class="text-center text-lg p-2 bg-gray-400"
        >
          <b>Purchase Option</b>
        </div>
        <div class="flex border-y-2">
          <div class="col-5 bg-gray-400 border-x-2 p-2 text-center text-xs">
            <b>Materials</b>
          </div>
          <div class="quote-flex-grow p-2 quote-border-r-2 text-right">
            {{ totals?.lineItemsMaterialPrice }}
          </div>
        </div>
        <div class="flex quote-border-b-2">
          <div class="col-5 bg-gray-400 border-x-2 p-2 text-center text-xs">
            <b>Services</b>
          </div>
          <div class="quote-flex-grow p-2 quote-border-r-2 text-right">
            {{ totals?.lineItemsServicesPrice }}
          </div>
        </div>
        <div class="flex quote-border-b-2">
          <div class="col-5 bg-gray-400 border-x-2 p-2 text-center text-xs">
            <b>Discounts</b>
          </div>
          <div class="quote-flex-grow p-2 quote-border-r-2 text-right">
            {{ totals?.lineItemsNegativeServicesPrice }}
          </div>
        </div>
        <div class="flex quote-border-b-2">
          <div class="col-5 bg-gray-400 border-x-2 p-2 text-center text-xs">
            <b>Import Surcharges</b>
          </div>
          <div class="quote-flex-grow p-2 quote-border-r-2 text-right">
            {{ totals?.lineItemsImportPrice }}
          </div>
        </div>
        <div class="flex quote-border-b-2">
          <div class="col-5 bg-gray-400 border-x-2 p-2 text-center text-xs">
            <b>Sales Tax</b>
          </div>
          <div class="quote-flex-grow p-2 quote-border-r-2 text-right">(1)</div>
        </div>
        <div class="flex quote-border-b-2">
          <div class="col-5 bg-gray-400 border-x-2 p-2 text-center text-xs">
            <b>Total</b>
          </div>
          <div class="quote-flex-grow p-2 quote-border-r-2 text-right">
            {{ totals?.lineItemsTotalPrice }}
          </div>
        </div>
        <p class="text-xs">
          (1) Applicable taxes will be included at time of invoice.
        </p>
      </div>
    </div>

    <div v-if="quoteTermsHtml" class="quote-text-tnc quote-terms-content quote-pb-before" v-html="quoteTermsHtml"></div>
  </div>
</template>

<script lang="ts" setup>
/* eslint-disable */
// @ts-nocheck

import { computed, toRefs, onMounted, onUnmounted, PropType } from "vue";
import { getQuoteLineUnitPrice, isQuoteAdjustmentLineItem } from "@/utils/quotePricing";

import {
  getUserDisplayName,
  formatCurrency,
  getQuoteTermsTemplate,
  isJobTypeWellTestRental,
  QuoteTermsTemplate,
} from "@/utils/quoteHelpers";
import { renderQuoteTermsHtml } from "./quoteTermsRenderer";
import {
  AllQuoteFieldsFragment as QuoteType,
  useUsersQuery,
  Quote_Line_Item_Category_Dataset_Enum as Category,
  Quote_Line_Item_Subcategory_Dataset_Enum as SubCategory
} from "gql/api";

const props = defineProps({
  quote: {
    type: Object as PropType<QuoteType | null>,
    default: null
  },
  advancedSearch: {
    type: Object,
    default: null
  }
});

const { quote, advancedSearch } = toRefs(props);

const { data: userItems, fetching: fetchingUsers } = useUsersQuery({
  variables: {}
});

const formatVersionNumber = (proposalNumber: string) => {
  if (!proposalNumber) {
    return "";
  }

  return proposalNumber.split("-")[0];
};

const quotePrintedDate = computed(() => {
  const now = new Date();
  return `${now.getMonth() + 1}/${now.getDate()}/${now.getFullYear()}`;
});

const quoteTermsTemplate = computed(() =>
  getQuoteTermsTemplate(
    advancedSearch?.value?.skJobType,
    advancedSearch?.value?.wellAddressSearch?.address?.region?.country?.code
  )
);

const totals = computed(() => {
  let lineItemsTotalPrice = 0;
  let lineItemsMaterialPrice = 0;
  let lineItemsServicesPrice = 0;
  let lineItemsNegativeServicesPrice = 0;
  let lineItemsImportPrice = 0;
  let lineItemsConsumablePrice = 0;
  let monthlyFee = 0;
  let dailyFee = 0;
  if (quote?.value?.quote_line_items) {
    for (const item of quote?.value?.quote_line_items) {
      if (item.tax_type === "free") {
        continue;
      }

      const itemTotal = getQuoteLineUnitPrice(item) * item.quantity;

      if (item?.erp_material_number === "1095537") { // Monthly Fee
        monthlyFee = getQuoteLineUnitPrice(item);
        continue;
      }

      if (item?.erp_material_number === "1095538") { // Daily Fee
        dailyFee = getQuoteLineUnitPrice(item);
        continue;
      }

      if (isQuoteAdjustmentLineItem(item)) {
        lineItemsNegativeServicesPrice += itemTotal;
      } else if (
        item?.erp_material_long_description.toLowerCase().includes("import")
      ) {
        lineItemsImportPrice += itemTotal;
      } else if (
        item?.category === Category.Equipment
      ) {
        lineItemsMaterialPrice += itemTotal;
      }  else if (
        item?.category === Category.Service
      ) {
        if (itemTotal < 0) {
          lineItemsNegativeServicesPrice += itemTotal;
        } else {
          lineItemsServicesPrice += itemTotal;
        }
      }

      if (item?.subcategory === SubCategory.Consumable) {
        lineItemsConsumablePrice += itemTotal;
      }

      lineItemsTotalPrice += itemTotal;
    }
  }
  return {
    lineItemsTotalPrice: formatCurrency(lineItemsTotalPrice, quote?.value?.currency),
    lineItemsMaterialPrice: formatCurrency(lineItemsMaterialPrice, quote?.value?.currency),
    lineItemsServicesPrice: formatCurrency(lineItemsServicesPrice, quote?.value?.currency),
    lineItemsNegativeServicesPrice: formatCurrency(lineItemsNegativeServicesPrice, quote?.value?.currency),
    lineItemsImportPrice: formatCurrency(lineItemsImportPrice, quote?.value?.currency),
    lineItemsConsumablePrice: formatCurrency(lineItemsConsumablePrice, quote?.value?.currency),
    lineItemsConsumableServiceMonthlyAggregate: formatCurrency(lineItemsConsumablePrice + lineItemsServicesPrice + monthlyFee, quote?.value?.currency),
    monthlyFee: formatCurrency(monthlyFee, quote?.value?.currency),
    dailyFee: formatCurrency(dailyFee, quote?.value?.currency),
  };
});

const quoteTermsHtml = computed(() =>
  renderQuoteTermsHtml(quoteTermsTemplate.value, {
    agreementDate: quotePrintedDate.value,
    customerName: quote?.value?.erp_customer_name ?? "",
    quoteName: quote?.value?.name ?? "",
    consumablesPrice: totals.value.lineItemsConsumablePrice,
    monthlyFee: totals.value.monthlyFee,
    dailyFee: totals.value.dailyFee,
  })
);

const isCanadaWellTest = () => {
  return quoteTermsTemplate.value === QuoteTermsTemplate.HGC_WELL_TEST;
};

const isCanadaDirectSale = () => {
  return (
    quoteTermsTemplate.value === QuoteTermsTemplate.HGC_SALE_TRADE ||
    quoteTermsTemplate.value === QuoteTermsTemplate.HGC_MONITORING
  );
};

const isUsaWellTest = () => {
  return quoteTermsTemplate.value === QuoteTermsTemplate.HESI_WELL_TEST;
};

const isUsaDirectSale = () => {
  return (
    quoteTermsTemplate.value === QuoteTermsTemplate.HESI_SALE_TRADE ||
    quoteTermsTemplate.value === QuoteTermsTemplate.HESI_MONITORING
  );
};

const quoteIsDraft = computed(() => {
  return quote?.value?.status === 'draft';
});

const preparePrint = () => {
  // Close all dropdowns and overlays
  const overlays = document.querySelectorAll('.v-overlay, .v-menu__content, .p-dropdown-panel, .p-autocomplete-panel');
  overlays.forEach(overlay => {
    if (overlay instanceof HTMLElement) {
      overlay.style.display = 'none';
    }
  });
};

onMounted(() => {
  // Close all dropdowns and overlays before printing
  window.addEventListener('beforeprint', preparePrint);
});

onUnmounted(() => {
  // Remove the event listener when the component is unmounted
  window.removeEventListener('beforeprint', preparePrint);
});

</script>

<style scoped>
.summit-logo {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */
  color-adjust: exact !important; /* Firefox 48 – 96 */
  print-color-adjust: exact !important; /* Firefox 97+, Safari 15.4+ */
}

.draft-watermark {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */
  color-adjust: exact !important; /* Firefox 48 – 96 */
  print-color-adjust: exact !important; /* Firefox 97+, Safari 15.4+ */
  background-image: url("/img/draft-watermark.png");
  background-size: 100vw 50vh;
  background-repeat: repeat-y;
}

.quote-header-bg-image {
  -webkit-print-color-adjust: exact !important; /* Chrome, Safari 6 – 15.3, Edge */
  color-adjust: exact !important; /* Firefox 48 – 96 */
  print-color-adjust: exact !important; /* Firefox 97+, Safari 15.4+ */
  background-image: url("/img/quote-header-bg-image.PNG");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.quote-pb-before {
  page-break-before: always;
}

.quote-text-tnc {
  font-size: smaller;
}

.quote-terms-content :deep(.quote-pb-before) {
  page-break-before: always;
}

.quote-terms-content :deep(table) {
  border-collapse: collapse;
  width: 100%;
}

.quote-terms-content :deep(td) {
  padding-right: 1rem;
  vertical-align: top;
}
.quote-list-upper-alpha {
  list-style-type: upper-alpha;
}

.quote-border-r-2 {
  border-right-width: 2px !important;
  border-right-style: solid;
}

.quote-border-b-2 {
  border-bottom-width: 2px !important;
  border-bottom-style: solid;
}

.quote-h-16 {
  min-height: 4rem !important;
  padding: 5px;
}

.quote-flex-grow {
  flex-grow: 1 !important;
}

.quote-pb-avoid {
  page-break-inside: avoid !important;
}

.quote-p-r-12 {
  padding-right: 6rem;
}

.quote-bg-purple {
  background-color: purple;
}

.quote-wrap-words {
  word-wrap: break-word;
}

.quote-desc-column {
  overflow: hidden;
}
</style>
